import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import MembershipPage from "@/pages/MembershipPage";
import SubscriptionSuccessPage from "@/pages/SubscriptionSuccessPage";
import QRCodePage from "@/pages/QRCodePage";
import EMRDashboard from "@/pages/emr/EMRDashboard";
import NewPatientForm from "@/pages/emr/NewPatientForm";
import UserManagement from "@/pages/emr/UserManagement";
import DocumentVisit from "@/pages/emr/DocumentVisit";
import PatientChart from "@/pages/emr/PatientChart";
import FollowUpCalls from "@/pages/emr/FollowUpCalls";
import ConciergeWidget from "@/components/ConciergeWidget";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/membership" element={<MembershipPage />} />
            <Route path="/subscription-success" element={<SubscriptionSuccessPage />} />
            <Route path="/qr-code" element={<QRCodePage />} />
            <Route path="/emr" element={<EMRDashboard />} />
            <Route path="/emr/patient/new" element={<NewPatientForm />} />
            <Route path="/emr/patient/:patientId" element={<PatientChart />} />
            <Route path="/emr/visit/document" element={<DocumentVisit />} />
            <Route path="/emr/users" element={<UserManagement />} />
            <Route path="/emr/followups" element={<FollowUpCalls />} />
          </Routes>
          <ConciergeWidget />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
